import menus from '../../../static/mock/menus.json'

export default {
  data () {
    return {
      menu_data: []
    }
  },
  methods: {
    checkDisplay (menus) {
      if (menus === 0) {
        $('.nav-treeview').hide()
        if (this.$store.state.screenWidth <= 736) {
          $('body').addClass('sidebar-collapse')
          $('body').removeClass('sidebar-open')
        }
      }
    },
    subCheckDisplay () {
      if (this.$store.state.screenWidth <= 736) {
        $('body').addClass('sidebar-collapse')
        $('body').removeClass('sidebar-open')
      }
    }
  },
  mounted () {
    if (sessionStorage.user) {
      this.$store.state.token = sessionStorage.token
      this.$store.state.user = JSON.parse(sessionStorage.user)
    }
    // this.menu_data = menus
    console.log(JSON.parse(sessionStorage.menu_page))
    this.menu_data = JSON.parse(sessionStorage.menu_page)
    console.log(this.menu_permission)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/slider.js